export const gitMetadata = {
    "commitHash": "291fb539aaf7eb036849866c51f7410d653e6330",
    "commitHashShort": "291fb53",
    "branch": "main",
    "isDirty": false,
    "buildTime": "2026-11-03T21:50:39.831Z"
};
//# sourceMappingURL=versionData.js.map